import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IUserDetails } from "modules/Profile/types";

interface UserProfileState {
  data: IUserDetails | null;
  loading: boolean;
  error: string | null;
}

const initialState: UserProfileState = {
  data: null,
  loading: false,
  error: null,
};

const userProfileSlice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    setUserProfileLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    setUserProfileSuccess: (state, action: PayloadAction<IUserDetails>) => {
      state.loading = false;
      state.error = null;
      state.data = action.payload;
    },
    setUserProfileError: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearUserProfile: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setUserProfileLoading,
  setUserProfileSuccess,
  setUserProfileError,
  clearUserProfile,
} = userProfileSlice.actions;

export default userProfileSlice.reducer; 